export default "__VITE_ASSET__df4e3f2c__"